<div class="d-flex justify-content-center align-items-center position-fixed m-0 p-0" id="loader">
    <img src="assets/images/payloading.gif" alt="" class="loader_image">
</div>